import React from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import AreaGraphRecharts from "../components/AreaGraph/RechartsAreaGraph";
import BarGraphRecharts from "../components/BarGraph/RechartsBarGraph";
import RechartsPieChart from "../components/PieChart/RechartsPieChart";
import RechartsDoughnutChart from "../components/DougnutPieChart/RechartsDoughnutChart";
import LeafletMap from "../components/Map/LeafletMap";

const TestCharts = () => {
  // Sample data for testing
  const areaData = {
    data: [
      { x: "2024-01-01", y: 100 },
      { x: "2024-01-02", y: 150 },
      { x: "2024-01-03", y: 120 },
      { x: "2024-01-04", y: 200 },
      { x: "2024-01-05", y: 180 },
      { x: "2024-01-06", y: 250 },
      { x: "2024-01-07", y: 300 },
    ]
  };

  const barData = {
    data: [
      { x: "Monday", y: 120 },
      { x: "Tuesday", y: 180 },
      { x: "Wednesday", y: 150 },
      { x: "Thursday", y: 200 },
      { x: "Friday", y: 250 },
      { x: "Saturday", y: 300 },
      { x: "Sunday", y: 280 },
    ]
  };

  const genderData = {
    gender: {
      Male: 450,
      Female: 320,
      Other: 80
    }
  };

  const ageData = {
    age: {
      "18-24": 250,
      "25-34": 380,
      "35-44": 200,
      "45-54": 120,
      "55+": 50
    }
  };

  const currencyData = {
    USD: 5000,
    EUR: 3000,
    GBP: 1500,
    SIKI: 2000,
    HBAR: 500
  };

  const mapData = [
    { x: "United States", y: 450 },
    { x: "United Kingdom", y: 200 },
    { x: "Canada", y: 150 },
    { x: "Germany", y: 120 },
    { x: "France", y: 100 },
    { x: "Japan", y: 80 },
    { x: "Australia", y: 70 },
    { x: "Brazil", y: 60 },
  ];

  return (
    <Box sx={{ p: 4, backgroundColor: "#090909", minHeight: "100vh" }}>
      <Typography variant="h4" sx={{ color: "#fff", mb: 4 }}>
        Recharts Test Page - Syncfusion Replacement
      </Typography>

      <Stack spacing={4}>
        {/* Area Chart */}
        <Box>
          <Typography variant="h6" sx={{ color: "#888", mb: 2 }}>
            Area Chart (Views Over Time)
          </Typography>
          <AreaGraphRecharts graph={areaData} tab="views" />
        </Box>

        {/* Bar Chart */}
        <Box>
          <Typography variant="h6" sx={{ color: "#888", mb: 2 }}>
            Bar Chart (Daily Statistics)
          </Typography>
          <BarGraphRecharts graph={barData} tab="tips" />
        </Box>

        {/* Pie Charts */}
        <Box>
          <Typography variant="h6" sx={{ color: "#888", mb: 2 }}>
            Pie Charts (Demographics)
          </Typography>
          <Stack direction="row" spacing={2}>
            <Box flex={1}>
              <RechartsPieChart lifeTimeCount={genderData} gender={true} />
            </Box>
            <Box flex={1}>
              <RechartsPieChart lifeTimeCount={ageData} gender={false} />
            </Box>
          </Stack>
        </Box>

        {/* Doughnut Chart */}
        <Box>
          <Typography variant="h6" sx={{ color: "#888", mb: 2 }}>
            Doughnut Chart (Currency Distribution)
          </Typography>
          <RechartsDoughnutChart currency={currencyData} />
        </Box>

        {/* Map */}
        <Box>
          <Typography variant="h6" sx={{ color: "#888", mb: 2 }}>
            Map (Geographic Distribution)
          </Typography>
          <LeafletMap data={mapData} location={true} tab="views" />
        </Box>
      </Stack>

      <Box sx={{ mt: 4, p: 2, backgroundColor: "#1a1a1a", borderRadius: 2 }}>
        <Typography variant="body2" sx={{ color: "#888" }}>
          ✅ All charts are now using free, open-source libraries (Recharts + Leaflet)
        </Typography>
        <Typography variant="body2" sx={{ color: "#888", mt: 1 }}>
          ✅ No Syncfusion license required
        </Typography>
        <Typography variant="body2" sx={{ color: "#888", mt: 1 }}>
          ✅ No usage limits or restrictions
        </Typography>
      </Box>
    </Box>
  );
};

export default TestCharts;